import React, { Component } from 'react'
import { isiPhoneX, compareSemver } from 'lib/is'
import t from 'locales'
import Modal from 'components/modal'
import noWalletIcon from 'assets/no-wallet.svg'
import updateAppIcon from 'assets/update-app.svg'
import { getAccounts } from 'lib/sdk'
import './index.scss'

interface Props {

}

interface State {
  modalVisible: boolean
  title: string
  desc: string
  icon: any
}

class SupportModal extends Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      modalVisible: false,
      title: '',
      desc: '',
      icon: ''
    }
  }

  componentDidMount() {
    this.checkSupport()
  }

  checkSupport = async () => {
    // not open in imToken
    if (!window['imToken']['callAPI']) return

    if (!window['imTokenAgent']) return
    // imToken version too low
    const version = (window['imTokenAgent'] || '').split(':')[1]
    if (!(version && compareSemver(version, '2.4.0') >= 0)) {
      this.setState({
        modalVisible: true,
        title: t('update_app_title'),
        desc: t('update_app_desc'),
        icon: updateAppIcon,
      });
      return
    }

    try {
      const accounts = await getAccounts()
      if (!accounts.length) {
        this.setState({
          modalVisible: true,
          title: t('no_wallet_title'),
          desc: t('no_wallet_desc'),
          icon: noWalletIcon,
        });
      }
    } catch (error) {
      console.warn(error)
    }
  }

  render() {
    const { title, desc, icon, modalVisible } = this.state

    if (!modalVisible) return null

    return (
      <Modal
        isOpen={true}
        contentLabel="imToken version Modal"
        onRequestClose={() => { }}
        styles={{ margin: '10px', bottom: isiPhoneX() ? '12px' : '0', borderRadius: '16px' }}
        appElement={document.body}
      >
        <div className="modal-inner">
          <img src={icon} alt={title} />
          <span>{title}</span>
          <div className="desc">{desc}</div>
          <div className="buttons">
            <div className="button confirm-button" onClick={this.onUnderstood}>{t('understood')}</div>
          </div>
        </div>
      </Modal>
    )
  }

  onUnderstood = () => {
    if (window['imToken']['callAPI']) {
      window['imToken'].callAPI('navigator.closeDapp')
    }
  }
}

export default SupportModal